"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIALOG_WIDTH = 310;
exports.DIALOG_WIDTH_WIDER = 325;
exports.VIEW_HEIGHT = 305;
